import React from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router, Switch, Route } from "react-router-dom";

import { DocumentationContextProvider } from "./store/documentation-context";

import ActaPage from "./pages/Acta";
import ContactPage from './pages/Contact';
import ErrorPage from "./pages/Error";
import HomePage from "./pages/Home";
import NotFoundPage from "./pages/NotFound";
import FinishedPage from "./pages/Finished";
import FilesPage from "./pages/Files";

import "./styles/index.scss";
import "./styles/fonts.scss";
import "./styles/buttons.scss";
import "./styles/datepicker.scss";
import "./styles/inputs.scss";

ReactDOM.render(
  <DocumentationContextProvider>
    <div className="main-content">
      <Router>
        <Switch>
          <Route path="/error">
            <ErrorPage />
          </Route>
          <Route path="/finished">
            <FinishedPage />
          </Route>
          <Route path="/contact">
            <ContactPage />
          </Route>
          <Route path="/files">
            <FilesPage />
          </Route>
          <Route path="/not-found">
            <NotFoundPage />
          </Route>
          <Route path="/acta">
            <ActaPage />
          </Route>
          <Route path="/">
            <HomePage />
          </Route>
        </Switch>
      </Router>
    </div>
  </DocumentationContextProvider>,
  document.getElementById("root")
);
